const updateLoggedInAgentState = (state, agentState) => {
  state.AGENT = {
    ...structuredClone(state.AGENT),
    stateId: agentState.stateId,
    stateName: agentState.stateName,
    reasonCode: agentState.reasonCode,
    breakDuration: agentState.breakDuration,
    timestamp: agentState.timestamp
  };
};

const updateSoftPhoneRegisteredState = (state, isRegistered) => {
  state.softPhoneState.isRegistered = isRegistered;
};

const updateIsRegisteringSoftPhone = (state, isRegistering) => {
  state.softPhoneState.isRegistering = isRegistering;
};

const updateSoftPhoneRegistrationErrors = (state, errors) => {
  state.softPhoneState.hasErrors = errors;
};

const updateLoggedInAgentLoadAllowance = (state, { loadAllowanceId, loadAllowanceName }) => {
  state.AGENT = {
    ...structuredClone(state.AGENT),
    loadAllowanceId,
    loadAllowanceName
  };
};

const updateLoggedInAgentAvatar = (state, avatar) => {
  if (!state.AGENT) {
    return;
  }

  state.AGENT.avatar = avatar;
};

const setRegistrationId = (state, registrationId) => {
  state.registrationId = registrationId;
};

const setLoggedInAgent = (state, agent) => {
  state.AGENT = agent;
};
const setTelephoneTerminals = (state, telephoneTerminals) => {
  state.telephoneTerminals = telephoneTerminals;
};

const removeLoggedInAgent = state => {
  state.AGENT = null;
};

const setAgentCurrentExtension = (state, { terminalType, terminalURI }) => {
  state.AGENT = {
    ...state.AGENT,
    currentExtension: {
      terminalType,
      terminalURI
    }
  };
};

const updateLoggedInAgentAvailableLoadAllowances = (state, loadAllowances) => {
  state.availableLoadAllowances = loadAllowances;
};

const setAgentAssignedBusinessProcessIds = (state, payload) => {
  if (!state.AGENT) {
    return;
  }

  if (payload.isAssigned) {
    state.AGENT.assignedBusinessProcessIds.push(payload.businessProcessId);
  } else {
    state.AGENT.assignedBusinessProcessIds = state.AGENT.assignedBusinessProcessIds.filter(
      item => item !== payload.businessProcessId
    );
  }
};

export default {
  setLoggedInAgent,
  setTelephoneTerminals,
  removeLoggedInAgent,
  setRegistrationId,
  updateLoggedInAgentState,
  updateLoggedInAgentLoadAllowance,
  updateLoggedInAgentAvatar,
  setAgentCurrentExtension,
  updateLoggedInAgentAvailableLoadAllowances,
  updateSoftPhoneRegisteredState,
  updateIsRegisteringSoftPhone,
  updateSoftPhoneRegistrationErrors,
  setAgentAssignedBusinessProcessIds
};
